import React, { Component } from 'react'
import config from '../../config';
import $ from 'jquery';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_RESPONSE, json } from '../../libs/utils/Const';
import { NavBar, GenericTable, BreadCumb, TimeOut, ReferralSystemPerson, SearchPartnerRefSys, SendReferralPartner } from '../../components';
import { ApiClient } from "../../libs/apiClient";
import { PartnerReferred, UserFields, ContactPersons, Addresses } from "../../components/NewOrder";

const apiClient = ApiClient.getInstance();

const headers = [
    { title: "Código" },
    { title: "Nombre" },
    { title: "Saldo" },
    { title: "Tipo" },
    { title: "Grupo" },
    { title: "RUT" },
    { title: "Embajador" },
    { title: "ACCIONES" },
];

class ReferredPartners extends Component {

    constructor(props) {
        super(props)
        this.state = {
            headers: headers
            , _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
            , data: []
            , referredModalAction: 1
            , referredModel: new PartnerReferred()
            , billingResponseArray: []
            , showReferredModal: false
            , enableSearchPartner: false
            , auxInfo: null


        };
    }

    componentDidMount = () => {
        this.SearchReferred()
    }

    SearchReferred = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getReferredPartners();
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: responseApi.data ?? [],
            });
        }
    }

    // GENERAL FUNCTIONS
    RefreshModel = (model) => {
        this.setState({
            referredModel: model
        })
    };

    // CREATE
    NewReferred = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (!_user || _user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }
        showAlert({ type: 'info', message: `Valida el RUT del cliente antes de llenar todo el formulario`, timeOut: 9000 });
        enableSpinner(true);
        let referredModel = new PartnerReferred();
        let userFieldsService = await apiClient.getUserFields({ name: 'OCRD' });
        userFieldsService = userFieldsService.data.header || [];
        let userFields = new UserFields();

        json.userFieldsPartners.forEach((item, index) => {
            const matchedField = userFieldsService.find(userfieldItem => item.fieldId === userfieldItem.header.FieldID);
            if (matchedField) {
                const { header, options } = matchedField;
                Object.assign(item, {
                    name: header.Descr,
                    fieldType: options.length ? 2 : item.fieldType,
                    options,
                    IdValue: index
                });

                if (item.fieldType === 2) {
                    item.options.push({ FldValue: "", Descr: "" });
                }

                userFields = this.setUserFieldValue(userFields, index, header);
            }
        });

        referredModel.userFields = userFields;
        this.setState({
            referredModel,
            referredModalAction: 1,
            showReferredModal: true,
        });

        $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    validateNull = (value) => (value === 0 ? 0 : (value || "").toString().trim());

    setUserFieldValue = (userFields, index, header) => {
        // Función auxiliar para evaluar condiciones especiales
        const validateField = (field, specialCondition = false) => {
            return specialCondition && !['inventoryRevaluation', 'bussinesPartner', 'administratorUsers', 'figuresTransport', 'transports', 'consignmentNote'].includes('bussinesPartner')
                ? field !== '' ? this.validateNull(field) : '99'
                : this.validateNull(field);
        };
        // Obtener el nombre del campo dynamic
        const fieldName = `userFields${index + 1}`;
        const headerField = header[fieldName];
        // Asignar el valor validado al campo correspondiente
        userFields[fieldName] = validateField(headerField, [20, 22, 24].includes(index));
        return userFields;
    };

    SendReferredPartnerModel = async partnerModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            model: partnerModel,
        };

        enableSpinner(true);
        const response = await apiClient.createBusinessPartner(data);
        enableSpinner(false);
        if (response.status !== 1) {
            showAlert({ type: 'error', message: `${response.message ?? ''}` });
            return;
        }

        $('#BussinesPartner').modal('hide');
        showAlert({ type: 'info', message: `${response.message}. Codigo cliente: ${response?.data?.docNumBilling ?? ''}` });

    };

    // SHOW 
    OpenBusinessPartnerDetails = async (register, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getPartnerDetails(register.CardCode);
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            const newOrderModel = this.fillBusinessPartnerDetailsModel(responseApi);
            this.setState({
                referredModel: newOrderModel,
                referredModalAction: 2, // show
                showReferredModal: true,
            });

            $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
            return;
        }

        showAlert({ type: 'error', message: responseApi.message });
    }

    fillBusinessPartnerDetailsModel = (model) => {
        let partnerModel = new PartnerReferred();
        const partner = model.data.partner;
        let userFieldsService = model.data.userFields;
        let contactPersons = model.data.contactPersons;
        let deliveriesAddress = model.data.deliveriesAddress;
        let invoicesAddress = model.data.invoicesAddress;
        let PayMethodCodes = model.data.methodsList;
        let BankAccounts = model.data.BankAccounts;

        let userFields = new UserFields();
        json.userFieldsPartners.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length !== 0 ? 2 : item.fieldType;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValue(userFields, index, partner);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            });
        });

        partnerModel.userFields = userFields;
        partnerModel.U_FMB_AMBASSADOR = partner?.U_FMB_AMBASSADOR ?? 'N'
        partnerModel.U_FMB_RELATED_AMBASSADOR = partner?.U_FMB_RELATED_AMBASSADOR ?? '';

        partnerModel.update = 1;
        partnerModel.CardCode = partner.CardCode;
        partnerModel.CardName = partner.CardName || '';
        partnerModel.GroupCode = partner.GroupCode || '';
        partnerModel.GroupCodeName = partner.GroupName || '';
        partnerModel.Balance = partner.Balance || 0;
        partnerModel.DocCur = partner.Balance || '';
        partnerModel.PayMethodCodes = PayMethodCodes || [];
        partnerModel.DNotesBal = partner.DNotesBal || 0;
        partnerModel.OrdersBal = partner.OrdersBal || 0;
        partnerModel.validFor = partner.validFor || 'N';
        partnerModel.CardType = partner.CardType || '';
        partnerModel.CardTypeName = partner.CardType === 'C' ? 'Cliente' : partner.CardType === 'S' ? 'Proveedor' : 'Lead';
        partnerModel.Currency = partner.Currency || '';
        partnerModel.CurrencyName = partner.CurrencyName || '';
        partnerModel.LicTradNum = partner.LicTradNum || '';
        partnerModel.Phone1 = partner.Phone1 || '';
        partnerModel.Phone2 = partner.Phone2 || '';
        partnerModel.E_mail = partner.E_Mail || '';
        partnerModel.SlpCode = partner.SlpCode || '';
        partnerModel.SlpName = partner.SlpName || '';
        partnerModel.GroupNum = partner.GroupNum || '';
        partnerModel.GroupNumName = partner.GroupNumName || '';
        partnerModel.PriceListNum = partner.ListNum || '';
        partnerModel.PriceListNumName = partner.PriceListNumName || '';
        partnerModel.CreditLine = partner.CreditLine || 0;
        partnerModel.DebtLine = partner.DebtLine || 0;
        partnerModel.Territory = partner.Territory || '';
        partnerModel.TerritoryName = partner.TerritoryName || '';
        partnerModel.CntctPrsn = partner.CntctPrsn || '';
        partnerModel.ShipToDef = partner.ShipToDef || '';
        partnerModel.BillToDef = partner.BillToDef || '';
        partnerModel.PymCode = partner.PymCode || '';
        partnerModel.PymCodeName = partner.PymCodeName || '';
        partnerModel.RefDetails = partner.RefDetails || '';
        partnerModel.TaxCode = partner.TaxCode || '';
        partnerModel.TaxName = partner.TaxName || '';
        partnerModel.DebPayAcct = partner.DebPayAcct || '';
        partnerModel.DebPayAcctName = partner.DebPayAcctName || '';
        partnerModel.FatherType = partner.FatherType || '';
        partnerModel.VatStatus = partner.VatStatus || '';
        partnerModel.BankAccounts = BankAccounts || [];
        partnerModel.BankCountr = partner.BankCountr || '';
        partnerModel.BankCode = partner.BankCode || '';
        partnerModel.DefaultBankCode = partner.DefaultBankCode || '';
        partnerModel.DflAccount = partner.DflAccount || '';
        partnerModel.DflSwift = partner.DflSwift || '';
        partnerModel.DflBranch = partner.DflBranch || '';
        partnerModel.BankCtlKey = partner.BankCtlKey || '';
        partnerModel.DflIBAN = partner.DflIBAN || '';
        // fields to downpayments
        partnerModel.DownPaymentClearAct = partner.DpmClear || '';
        partnerModel.DownPaymentInterimAccount = partner.DpmIntAct || '';
        partnerModel.U_PTruper = partner.U_PTruper || '';
        partnerModel.U_Ppago = Number(partner.U_Ppago || '0').toFixed(2);


        let contactPersonArray = [];
        let deliveriesArray = [];
        let invoicesArray = [];
        contactPersons.map((contact, index) => {
            let newContact = new ContactPersons();
            newContact.Name = contact.Name || '';
            newContact.Active = contact.Active || '';
            newContact.FirstName = contact.FirstName || '';
            newContact.Title = contact.Title || '';
            newContact.MiddleName = contact.MiddleName || '';
            newContact.Position = contact.Position || '';
            newContact.LastName = contact.LastName || '';
            newContact.Tel1 = contact.Tel1 || '';
            newContact.Tel2 = contact.Tel2 || '';
            newContact.Cellolar = contact.Cellolar || '';
            newContact.Fax = contact.Fax || '';
            newContact.E_MailL = contact.E_MailL || '';
            newContact.Notes1 = contact.Notes1 || '';
            newContact.Notes2 = contact.Notes2 || '';

            contactPersonArray.push(newContact);
            if (partnerModel.CntctPrsn === contact.Name) {
                partnerModel.contactEditIndex = index;
            }
        });

        invoicesAddress.map((address, index) => {
            let newAddress = new Addresses();

            newAddress.Address = address.Address || '';
            newAddress.Street = address.Street || '';
            newAddress.Block = address.Block || '';
            newAddress.City = address.City || '';
            newAddress.ZipCode = address.ZipCode || '';
            newAddress.County = address.County || '';
            newAddress.State = address.State || '';
            newAddress.Country = address.Country || '';
            newAddress.TaxCode = address.TaxCode || '';
            newAddress.StreetNo = address.StreetNo || '';
            newAddress.Building = address.Building || '';
            newAddress.GlblLocNum = address.GlblLocNum || '';
            newAddress.TaxOffice = address.TaxOffice || '';
            newAddress.TypeOfAddress = address.AdresType || '';

            invoicesArray.push(newAddress);
            if (partnerModel.BillToDef === address.Address) {
                partnerModel.invoicesAddressEditIndex = index;
            }
        });

        deliveriesAddress.map((address, index) => {
            let newAddress = new Addresses();

            newAddress.Address = address.Address || '';
            newAddress.Street = address.Street || '';
            newAddress.Block = address.Block || '';
            newAddress.City = address.City || '';
            newAddress.ZipCode = address.ZipCode || '';
            newAddress.County = address.County || '';
            newAddress.State = address.State || '';
            newAddress.Country = address.Country || '';
            newAddress.TaxCode = address.TaxCode || '';
            newAddress.StreetNo = address.StreetNo || '';
            newAddress.Building = address.Building || '';
            newAddress.GlblLocNum = address.GlblLocNum || '';
            newAddress.TaxOffice = address.TaxOffice || '';
            newAddress.TypeOfAddress = address.AdresType || '';

            deliveriesArray.push(newAddress);
            if (partnerModel.ShipToDef === address.Address) {
                partnerModel.deliveriesAddressEditIndex = index;
            }
        });

        partnerModel.ContactPersons = contactPersonArray;
        partnerModel.DeliveriesAddress = deliveriesArray;
        partnerModel.InvoicesAddress = invoicesArray;
        return partnerModel;
    };

    // UPDATE
    UpdateReferredPartner = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { referredModel, _user } = this.state;

        const data = {
            model: referredModel,
            email: _user.E_Mail
        };

        enableSpinner(true);
        const response = await apiClient.updateBusinessPartner(data);
        enableSpinner(false);

        if (response.status !== 1) {
            showAlert({ type: 'error', message: response.message, timeOut: 9999 });
            return
        }
        showAlert({ type: 'success', message: response.message, timeOut: 9999 });

        this.setState({
            showReferredModal: false
        })
        // await this.OpenBusinessPartnerDetails(referredModel.CardCode);
        this.SearchReferred()
    }

    OpenSearchPartner = async () => {
        await this.setState({
            enableSearchPartner: true
        });

        $('#searchPartnerRefSys').modal('show');
    }

    SearchPartnerCloseAct = async () => {
        await this.setState({
            enableSearchPartner: false
        });
    }

    ReceiveInfoByInfo = async (info) => {
        $('#searchPartnerRefSys').modal('hide');
        await this.setState({
            auxInfo: info,
            enableSearchPartner: false
        })

        $('#sendReferralPartner').modal('show');
    }


    SendDataToConvert = async (CardCode, AmbassadorCode) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            CardCode: CardCode,
            AmbassadorCode: AmbassadorCode
        }
        enableSpinner(true);
        const responseApi = await apiClient.converToReferred(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message, timeOut: 9999 });
            return
        }
        showAlert({ type: 'success', message: responseApi.message, timeOut: 9999 });
        $('#sendReferralPartner').modal('hide');
        $('#searchPartnerRefSys').modal('hide');
    }

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { headers, data, _user, referredModel, referredModalAction } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'EMBAJADORES'} url1={'#'} />


                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label className="text-muted">REFERIDOS</label>
                    </h2>
                    <div className='row'>
                        <div className="col-md-6 ">
                            <button className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1" disabled onClick={this.NewReferred} style={{ width: 252, borderColor: "#A7A6A5", marginRight: "1vh" }} >
                                <i className="far fa-user"></i> <span className="d-none d-xl-inline"> Crear cliente referido</span>
                                <span className="d-inline d-xl-none">Crear Referido</span>
                            </button>
                            <button className="btn btn-active" onClick={() => this.OpenSearchPartner()}
                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right", marginRight: "1vh" }}>
                                <i className="fa fa-address-book-o"></i>
                            </button>
                            <button className="btn btn-outline-dark" onClick={() => this.SearchReferred()} > <i className="fa fa-refresh" /> </button>

                        </div>
                        <div className="col-md-6 mb-2">
                        </div>

                    </div>

                    <SendReferralPartner
                        info={this.state.auxInfo}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        SendDataToConvertProps={this.SendDataToConvert}
                    />

                    {this.state.enableSearchPartner &&
                        <SearchPartnerRefSys
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            actionLabel={"Convertir a referido"}
                            typeSearch={'SearchPossibleReferreds'}
                            closeAction={this.SearchPartnerCloseAct}
                            ReceiveFather={this.ReceiveInfoByInfo}
                        />
                    }

                    <GenericTable
                        headers={headers}
                        data={data}
                        view={'referredPartners'}
                        enableSearchInTable={true}
                        action={this.OpenBusinessPartnerDetails}
                    />

                    {this.state.showReferredModal &&
                        <ReferralSystemPerson
                            view={'bussinesPartner'}
                            auxView={'referredPartner'}
                            partnerModel={referredModel}
                            action={referredModalAction}
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            writeAccess={true}
                            refreshModel={this.RefreshModel}
                            sendModel={this.SendReferredPartnerModel}
                            acceptEditMode={this.UpdateReferredPartner}
                            cancelEditMode={this.CancelEditModePartner}
                            billingResponseArray={this.state.billingResponseArray}
                        // ref={(ref) => this.bussinesPartnerModal = ref}
                        />}

                </div>
            </div>
        )
    }

}


const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReferredPartners);
